var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [_vm._v(_vm._s(_vm.downloadingText))]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "divloadingexport" + _vm.keyId, staticClass: "modal-body" },
        [
          _c("div", { staticClass: "position-relative" }, [
            _c("div", { staticClass: "h100" }, [
              _c("div", { staticClass: "container h-100" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row h-100 justify-content-center align-items-center",
                  },
                  [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "h-100 text-center" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.excelError,
                                expression: "excelError",
                              },
                            ],
                            staticClass: "alert alert-danger",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("span", {
                              staticClass: "mdi mdi-alert-rhombus-outline",
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.errorText) +
                                "\n                                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.excelError,
              expression: "excelError",
            },
          ],
          attrs: { medium: "", elevation: "3" },
          on: { click: _vm.close },
        },
        [_vm._v("\n        " + _vm._s(_vm.$t("common.lblClose")) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }